import {
  IAcademicBackEndModelSecondary,
  IAcademicFormModelSecondary,
} from "../../../types";

export function parseToBackEndModel(
  frontendModel: IAcademicFormModelSecondary,
  schoolId: string,
  academicId?: string,
): IAcademicBackEndModelSecondary {
  const schoolLevel =
    frontendModel.schoolLevels[frontendModel.selectedSchoolLevel.id];
  const backendModel = {} as IAcademicBackEndModelSecondary;

  backendModel.schoolId = schoolId;
  backendModel.levelId = +frontendModel.selectedSchoolLevel.id.substring(1);
  backendModel.schoolType = schoolLevel.schoolType!.id;

  if (backendModel.levelId === 3) {
    backendModel.grade =
      schoolLevel.otherGrade || schoolLevel.schoolGrade!.name;
  }

  if (academicId) {
    backendModel.id = academicId;
  }

  backendModel.requiredDocs = schoolLevel.requiredDocs.map((doc) => {
    const parsedDoc = { ...doc };
    delete parsedDoc.shortName;
    delete parsedDoc.longName;

    return parsedDoc;
  });

  Object.entries(schoolLevel.additionalDocuments || {}).forEach(
    ([id, name]) => {
      if (!name.trim()) {
        return;
      }

      const doc: { id?: string; name: string } = { name: name.trim() };

      if (!id.startsWith("_")) {
        doc.id = id;
      }

      backendModel.requiredDocs.push(doc);
    },
  );

  if (schoolLevel.applicationForms.length) {
    backendModel.applicationForms = schoolLevel.applicationForms.map(
      (form) => ({
        fileId: form.id,
        name: form.name,
        size: form.size,
      }),
    );
  } else {
    backendModel.applicationForms = [];
  }

  if (schoolLevel.applicationLink) {
    backendModel.applicationLink = schoolLevel.applicationLink.trim();
  } else {
    backendModel.applicationLink = null;
  }

  return backendModel;
}
